import OrganizationProvider from "../../../../common/providers/organizationProvider";
import Folder from "../../../document_management/models/folder";

export default function () {
  return window.AppConfig.mergeJson({
    namespaced: true,
    state: {
      organizationProvider: <OrganizationProvider>new OrganizationProvider(),
      organization_folder: null,
      organization: null
    },
    mutations: {
      setOrganization(state, {organization}) {
        state.organization = organization
      },
      setFolders(state, {folders}) {
        state.organization_folder = new Folder().loadFromJson(folders[0]);
        state.organization_folder.parent = state.organization;
      },
      setDocuments(state, {folder, documents}) {
        const forms = [];
        const licenses = [];
        const certificates = [];
        const objectModels = [];
        const listViews = [];
        documents.forEach(d => {
          switch (d.type) {
            case 'form':
              forms.push(d);
              break;
            case 'license':
              licenses.push(d);
              break;
            case 'certificate':
              certificates.push(d);
              break;
            case 'object_model':
              objectModels.push(d);
              break;
            case 'list_view':
              listViews.push(d);
              break;
            default:
              break;
          }
        });
        folder.loadFromJson({
          forms: forms,
          licenses: licenses,
          certificates: certificates,
          object_models: objectModels,
          list_views: listViews,
        });
      },
    },
    actions: {

      fetchFolders({commit, state}, {organization}): Promise<any> {
        return new Promise((resolve, reject) => {
          state.organizationProvider.fetchFolders({organizationId: organization.id})
            .then(response => {
              commit('setFolders', {folders: response.folders});
              resolve();
            });
        });
      },

      fetchDocuments({commit, state}, {folder}) {
        return new Promise((resolve, reject) => {
          state.organizationProvider.fetchDocuments({folder: folder, query: '*'}).then(
            result => {
              commit('setDocuments', {folder: folder, documents: result.documents});
              folder.fetchingDocuments = false;
              resolve(result);
            }
          );
        });
      },

    }
  });
}

